import useFileUpload from '../../hooks/uploadFile.js';

const TestMyara = () => {
    const {
        files,
        uploadedFiles,
        uploadProgress,
        handleFileChange,
        startUpload,
      } = useFileUpload();

    return (
        <div className="test-myara-container">
            <h2 className="dash-section-title">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                Test Myara - Caricamento File
            </h2>
            
            <div className="dash-form-grid" style={{ marginTop: '1.25rem' }}>
                <div className="dash-field-group" style={{ gridColumn: '1 / -1' }}>
                    <label>Seleziona File da Caricare</label>
                    <input 
                        type="file" 
                        onChange={handleFileChange} 
                        multiple 
                        className="dash-input-text" 
                        style={{ cursor: 'pointer' }}
                    />
                </div>

                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <button onClick={startUpload} className="btn-action primary">
                        Avvia Caricamento
                    </button>
                </div>
            </div>

            {files.length > 0 && (
                <div className="toast-info" style={{ marginTop: '1rem', background: 'var(--bg-surface)', padding: '1rem', borderRadius: 'var(--radius-md)', border: '1px solid var(--border-color)' }}>
                    <strong>File Selezionati:</strong> {files.map((file) => file.name).join(', ')}
                </div>
            )}

            {Object.keys(uploadProgress).length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                    <h4>Avanzamento Upload:</h4>
                    {Object.keys(uploadProgress).map((fileName) => (
                        <div key={fileName} style={{ fontSize: '0.88rem', color: 'var(--text-muted)', margin: '0.3rem 0' }}>
                            {fileName}: <strong>{uploadProgress[fileName]}%</strong>
                        </div>
                    ))}
                </div>
            )}

            {uploadedFiles.length > 0 && (
                <div className="progetti-table-card" style={{ marginTop: '1.5rem', padding: '1.25rem' }}>
                    <h3 className="dash-section-title">File Caricati con Successo</h3>
                    <ul style={{ listStyle: 'circle', paddingLeft: '1.5rem', color: 'var(--accent-success)' }}>
                        {uploadedFiles.map((file) => (
                            <li key={file.name} style={{ margin: '0.3rem 0' }}>{file.name}</li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default TestMyara;